import { useState } from "react"
import { DateRangePicker } from "../shared/dateRangePicker"
import { MultiSearchSelect } from "../shared/searchSelectMulti"
import { SearchFiltersModal } from "../shared/searchFiltersModal"
import stringHelpers from "../../utilities/stringHelpers"
import { toDateString } from "../../utilities/dateUtilities"
import { TagSelector } from "../shared/tagSelector"
import appliedFiltersUtilities from "../../utilities/appliedFiltersUtilities"
import arrayUtilities from "../../utilities/arrayUtilities"

export const EnforcementSuspensionsFiltersModal = ({
	showModal,
	handleClose,
	handleConfirm,
	initialFilterStart,
	initialFilterEnd,
	initialSelectedSites,
	initialSelectedTags = [],
	initialAppliedFilters,
	sites = [],
	tags = []
}) => {
	const [filterStart, setFilterStart] = useState(initialFilterStart)
	const [filterEnd, setFilterEnd] = useState(initialFilterEnd)
	const [selectedSites, setSelectedSites] = useState(initialSelectedSites)
	const [selectedTags, setSelectedTags] = useState(initialSelectedTags)
	const [appliedFilters, setAppliedFilters] = useState(initialAppliedFilters)

	const clearLocalFilters = () => {
		setFilterStart(null)
		setFilterEnd(null)
		setSelectedSites(null)
		setSelectedTags([])
		setAppliedFilters(null)
	}

	const handleTagsChange = tagSelections => {
		setSelectedTags(tagSelections)
		setAppliedFilters(prevState => appliedFiltersUtilities.applyMultiSelection(prevState, "Tags", tagSelections, tags))
	}

	const handleSitesChange = siteIds => {
		setSelectedSites(siteIds)
		setAppliedFilters(prevState => appliedFiltersUtilities.applyMultiSelection(prevState, "Sites", siteIds, sites))
	}

	return (
		<SearchFiltersModal
			title="Filter Results"
			handleClose={ handleClose }
			handleConfirm={ () => handleConfirm({ filterStart, filterEnd, selectedSites, selectedTags, appliedFilters }) }
			showModal={ showModal }
			key="enforcement-suspensions-filters-modal"
			handleReset={ clearLocalFilters }
		>
			<div className="w-100">
				<div className="mb-2">
					<label className="m-0 mr-2 mb-1 nowrap">Date Range</label>
					<DateRangePicker
						fromDate={ filterStart }
						toDate={ filterEnd }
						setDateRange={ (firstDate, lastDate, presetLabel) => {
							const isFirstDateEmpty = firstDate === null || firstDate === ""
							const isLastDateEmpty = lastDate === null || lastDate === ""
							setFilterStart(isFirstDateEmpty ? null : firstDate);
							setFilterEnd(isLastDateEmpty ? null : lastDate);
							if (!stringHelpers.isNullOrEmpty(presetLabel)) {
								setAppliedFilters(prevState => {
									const updatedFilters = { ...prevState }
									delete updatedFilters.From
									delete updatedFilters.To
									updatedFilters["Date Range"] = presetLabel
									return updatedFilters
								})
							}
							else {
								setAppliedFilters(prevState => {
									const updatedFilters = { ...prevState }
									if (!isFirstDateEmpty && !isLastDateEmpty) {
										delete updatedFilters.From
										delete updatedFilters.To
										updatedFilters["Date Range"] = `${toDateString(new Date(firstDate))} - ${toDateString(new Date(lastDate))}`
									} else {
										if (!isFirstDateEmpty) {
											updatedFilters.From = toDateString(new Date(firstDate))
										} else {
											delete updatedFilters.From
										}
										if (!isLastDateEmpty) {
											updatedFilters.To = toDateString(new Date(lastDate))
										} else {
											delete updatedFilters.To
										}
										delete updatedFilters["Date Range"]
									}
									return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
								})
							}
						}}
						showClearOption
						hideLabel
						fullWidth
						dropdownPositionRight
					/>
				</div>

				<div className="d-flex flex-column mb-2">
					<label className="m-0 mr-2 mb-1 nowrap">Sites</label>
					<MultiSearchSelect
						width="100%"
						options={ sites.map(item => ({ value: item.id, label: item.name })) }
						selectedValues={ selectedSites }
						defaultLabel="All"
						unit="sites"
						onChange={ handleSitesChange }
					/>
				</div>

				{ !arrayUtilities.isNullOrEmpty(tags) && <div className="d-flex flex-column mb-2">
					<div className="d-flex align-items-center justify-content-between">
						<label className="m-0 mr-2 mb-1 nowrap">Tags</label>
						<button onClick={ () => handleTagsChange([]) } className="btn btn-none m-0 p-0 fs--1 mb-1" type="button">Clear tags</button>
					</div>
					<TagSelector
						onChange={ handleTagsChange }
						selectedTags={ selectedTags }
						tags={ tags }
					/>
				</div> }
			</div>
		</SearchFiltersModal>
	)
}
